import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';

const NavArrowLeft = ({ ...props }: IconProps) => {
  return (
    <IconWrapper {...props} variant="outline">
      <path d="M15 6L9 12L15 18" strokeLinecap="round" strokeLinejoin="round" />
    </IconWrapper>
  );
};

export { NavArrowLeft };
